module.exports = __webpack_public_path__ + "img/coupon.4e955b99.svg";